module.exports = __webpack_public_path__ + "media/images/bg_mv_purchasing_mansion-97d6239a0b950a5f0006356f0c48c337.jpg";